import Image from 'next/image'
import Button from '../Button'
import {useQuery} from 'react-query'
import GetCovers from '@/services/api/personalize/GetCovers'
import React, {Dispatch, SetStateAction} from 'react'
import CustomToast from '../CustomToast'
import toast from 'react-hot-toast'
interface Props {
  product: any
  inputCover: string | undefined
  setInputCover: Dispatch<SetStateAction<string | undefined>>
  SubmitChange?: any
  close?: any
  isEdit?: any,
  setCoverModal?: any,
  updateProductData?:any
  handleSave?: any
  markOptionCompleted?:any
}
export default function CoversSelection({
  product,
  inputCover,
  SubmitChange,
  setInputCover,
  close = undefined,
  isEdit,
  setCoverModal,
  updateProductData,
  handleSave,
  markOptionCompleted
}: Props) {
  React.useEffect(() => {
    if (isEdit === '1' && product?.cover_id) {
        setInputCover(product.cover_id)
      }
  }, [isEdit, product?.cover_id])
  const product_id = isEdit === '1' ? product?.product_id : product?.id;
  const {data, isLoading} = useQuery(['covers', product_id], GetCovers)
  return (
    <div className="personalization-content covers-selection items-center w-full xl:mx-auto xl:max-w-xl px-4">
      <h3 className="block lg:hidden text-base font-bold">اختر غلاف كتابك</h3>
      <div className='hidden lg:flex w-full items-center justify-between lg:mb-3'>
        <h3 className="text-base font-bold">اختر غلاف كتابك</h3>
        <button 
            className="bg-[#93A3B03D] text-xl p-2 rounded-md" 
            onClick={()=>{
              setCoverModal(false);
            }}
          >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.23742 7.00023L13.7439 1.88765C14.0857 1.57026 14.0857 1.05566 13.7439 0.738291C13.4021 0.420895 12.8479 0.420895 12.5061 0.738291L7.00022 5.8514L1.49438 0.738291C1.15257 0.420895 0.598385 0.420895 0.256602 0.738291C-0.0851811 1.05569 -0.0852084 1.57028 0.256602 1.88765L5.76302 7.00023L0.256602 12.1128C-0.0852084 12.4302 -0.0852084 12.9448 0.256602 13.2622C0.598412 13.5796 1.15259 13.5796 1.49438 13.2622L7.00022 8.14905L12.5061 13.2622C12.8479 13.5796 13.4021 13.5796 13.7438 13.2622C14.0857 12.9448 14.0857 12.4302 13.7438 12.1128L8.23742 7.00023Z" fill="black"/>
          </svg>
        </button>
      </div>
      {!isLoading ? 
      (
        <div className="covers-list w-full mt-2 flex flex-col mx-auto gap-2">
        {data?.map((cover: any, index: number) => {
          return (
            <a
              href="#"
              key={cover.id}
              onClick={e => {
                e.preventDefault()
                setInputCover(cover.id)
              }}
              className={`cover transition duration-200 mt-1 lg:mt-0 cursor-pointer border-2 flex flex-col p-4 rounded-lg lg:items-start lg:w-full bg-white ${
                (inputCover == cover.id) ? 'border-primary' : ''
              } gap-1`}>
              <div className="cover-image h-[120px] lg:h-[132px] lg:w-full flex items-center justify-center bg-gray-200">
                <Image
                  src={
                    cover.type === '1' ? '/images/hard-cover.png' : '/images/soft-cover.png'
                  }
                  width={200}
                  height={150}
                  alt={cover.name}
                  unoptimized
                  priority
                  className={'w-full h-full max-h-[120px] lg:max-h-[132px] rounded-md object-cover'}
                />
              </div>
              <h4 className="mt-4 text-base font-medium">{cover.name}</h4>
              <p className="text-sm text-text-color font-normal">
                {cover.description}
              </p>
              <strong className="price text-red text-2xl font-bold mt-1">{cover.price} ₪</strong>
            </a>
          )
        })}
      </div>
      )
      : 
      (
      <div className='flex-1 overflow-y-auto px-4 py-6 bg-[#FFFCEB] flex items-center justify-center gap-4'>
        <div className="w-6 h-6 border-4 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
        <h2 className="text-lg font-semibold leading-none">تحميل أنواع الغطاء...</h2>
      </div>
      )}

      <Button
        type="button"
        bg="primary"
        onClick={() => {
          if (!inputCover || inputCover === '' || inputCover === undefined) {
            toast.custom((t) => <CustomToast t={t} message={'الرجاء اختيار غطاء قبل الاستمرار'} type="error" />);
            return
          }
          updateProductData({cover: inputCover});
          markOptionCompleted('cover', true);
          handleSave();
          setCoverModal(false)
        }}
        classes={['py-3', 'w-full', 'mt-4', 'font-semibold', 'hidden', 'lg:block', 'lg:mt-6']}>
        {'متابعة'}
      </Button>
    </div>
  )
}
